export const CATEGORY_LOAD = 'CATEGORY_LOAD';
export const CATEGORY_LOADED = 'CATEGORY_LOADED';
export const CATEGORY_UNLOAD = 'CATEGORY_UNLOAD';
export const CATEGORY_UPDATE = 'CATEGORY_UPDATE';
export const CATEGORY_UPDATE_SUCCESS = 'CATEGORY_UPDATE_SUCCESS';
export const CATEGORY_IMAGE_UPLOAD = 'CATEGORY_IMAGE_UPLOAD';
